import React from 'react'

interface Props {
  can?: boolean
  children: React.ReactNode
}

const UserCan: React.FC<Props> = ({ can, children }) => {
  if (!can) return null

  return <>{children}</>
}

export default UserCan
